export const acquisitionsFiltersMapping = {
  'q[price_usd_lt]': 'q[price_usd_lt]',
  'q[price_usd_gt]': 'q[price_usd_gt]',
  'q[acquisition_type_matches_any][]': 'acquisition_type',
  'q[acquisition_terms_matches_any][]': 'acquisition_terms'
};
